import {Component, OnInit} from '@angular/core';
import * as moment from 'moment';
import {AppCommunicationService} from '../../services/app-communication.service';
import {StatisticService} from '../../services/statistic.service';
import {I18nService} from '../../../shared/i18n';
import {StatisticModel, TableModel} from '../../models/statistic.model';

@Component({
    selector: 'app-statistics-view',
    templateUrl: './statistics-view.component.html',
    styleUrls: ['./statistics-view.component.scss']
})
export class StatisticsViewComponent implements OnInit {

    reportGenerated = false;
    selectedYear = [];
    yearFilter = {
        data: [],
        settings: {
            singleSelection: true,
            idField: 'item_id',
            textField: 'item_text',
            selectAllText: 'Označiť všetko',
            unSelectAllText: 'Odznačiť všetko',
            itemsShowLimit: 2,
            allowSearchFilter: false
        }
    };
    statisticData: StatisticModel;

    constructor(private _appCommunicationService: AppCommunicationService,
                private i18nService: I18nService,
                private statisticService: StatisticService) {
        this.generateYearsFilter();
    }

    ngOnInit() {
        this.generateReport();
    }

    generateYearsFilter() {
        let initYear = Number.parseInt(moment(Date.now()).format('YYYY'));
        const endYear = 2010;

        while (initYear >= endYear) {
            const year = {
                item_id: initYear,
                item_text: initYear.toString()
            };
            this.yearFilter.data.push(year);
            if (initYear === 2018) {
                this.selectedYear.push(year)
            }
            initYear--;
        }
    }

    generateReport() {
        setTimeout(() => {
            this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Loading data'));
        });
        this.statisticService.getStatistic(this.selectedYear[0].item_id).subscribe((data: StatisticModel) => {
            this.statisticData = data;
            this.pivotModule1Table();
            console.log(this.statisticData);
        }, (err) => {
            this._appCommunicationService.loadingOff();
        });

    }

    pivotModule1Table() {
        console.log(this.statisticData.firstTable)
        if (this.statisticData && this.statisticData.firstTable) {
            const newTableData = new TableModel();
            newTableData.header = [];
            newTableData.body = [];

            // newTableData.header.push(this.statisticData.firstTable.header[0]);
            newTableData.header.push(' ');

            this.statisticData.firstTable.header.shift();

            for (let i  = 0; i < this.statisticData.firstTable.body.length; i++) {
                newTableData.header.push(this.statisticData.firstTable.body[i][0]);
                this.statisticData.firstTable.body[i].shift();
            }

            this.statisticData.firstTable.header.forEach(headerItem => {
                newTableData.body.push([headerItem])
            })

            for (let i = 0; i < this.statisticData.firstTable.body.length; i++) {

                for (let j = 0; j < this.statisticData.firstTable.body[0].length; j++) {

                    newTableData.body[j].push(this.statisticData.firstTable.body[i][j]);

                }

            }

            Object.assign(this.statisticData.firstTable, newTableData);

            this.reportGenerated = true;
            this._appCommunicationService.loadingOff();

            // this.statisticData.firstTable = Obj;


            console.log(newTableData)
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/views/statistics-view/statistics-view.component.ts